import app from "./subsystems/app/selectors";
import clients from "./subsystems/clients/selectors";
import { selectors as user } from "@lifepay/redux-subsystem-user";
import { selectorsGen as access } from "@lifepay/redux-subsystem-access";
import storeShape from "./storeShape";

export default {
  app: app(storeShape),
  clients: clients(storeShape),
  user: user(storeShape),
  access: access(["access"]),
};



// WEBPACK FOOTER //
// ./src/model/selectors.js